import React, { useState } from "react";
import axios from "axios";
import "./Dictionary.css";
import Results from "./Results";
import Photos from "./Photos";

export default function Dictionary() {
  let [keyword, setKeyword] = useState("");
  let [results, setResults] = useState(null);
  let [photos, setPhotos] = useState();

  function handleResponse(response) {
    console.log(response.data);
    setResults(response.data[0]);
  }
  function handlePexels(response) {
    setPhotos(response.data.photos);
  }
  function search(event) {
    event.preventDefault();

    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleResponse);

    let pexelsApi = `563492ad6f91700001000001af835d876ebe4281adfe59d13ab0d3f3`;
    let pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
    axios
      .get(pexelsUrl, { headers: { Authorization: `Bearer ${pexelsApi}` } })
      .then(handlePexels);
  }

  function handleKeyword(event) {
    setKeyword(event.target.value);
  }
  return (
    <div className="Dictionary">
      <section>
        <div className="Info">Please type the word you want to look up.</div>
        <form onSubmit={search}>
          <input type="search" onChange={handleKeyword} />
        </form>
      </section>
      <br />
      <hr className="line-search" />
      <Results results={results} />
      <Photos photos={photos} />
    </div>
  );
}
